<template>
  <div class="table__primary">
    <div class="h-full">
      <div>
        <div class="flex flex-wrap justify-between text-sm">
          <div>
            <slot name="header"></slot>
          </div>
          <div v-if="search" class="mb-2">
            <div
              class="flex border-2 place-items-center text-base rounded-md px-2 transition-all"
              :class="isFocus ? 'border-blue-primary' : ''"
            >
              <input
                type="text"
                :placeholder="search.placeholder || 'Cari'"
                v-model="searchInput"
                @input="searchData"
                @focus="isFocus = true"
                @blur="isFocus = false"
                class="p-2 outline-none"
              />
              <font-awesome :icon="['fa', 'search']" />
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-auto text-sm rounded">
        <table class="w-full table">
          <thead>
            <tr class="font-bold-pop select-none">
              <th class="table__title">#</th>
              <th
                v-for="(item, id) in thead"
                :key="id"
                :class="`table__title ${item.disableSort ? '' : '--sort'}`"
                @click="
                  !item.disableSort && sortData(item.id || item.title, id + 1)
                "
              >
                <div
                  v-if="!item.disableSort"
                  class="flex text-center justify-center place-items-center"
                  :class="active == id + 1 ? 'text-yellow-300' : ''"
                >
                  {{ item.title }}
                  <div
                    :class="`transition-bounce w-30 text-lg transform  ${
                      ascending && active == id + 1 ? 'rotate-180' : ''
                    }`"
                  >
                    <font-awesome :icon="['fa', 'angle-up']" />
                  </div>
                </div>
                <div v-else>
                  {{ item.title }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody v-if="listsLocalSearch.length > 0">
            <tr v-for="(list, i) in listsLocalShow" :key="i">
              <td>{{ i + 1 + maxItems * currentPage }}</td>
              <template v-for="(item, name, i) in list">
                <td
                  v-if="name != 'usedDataList' && !thead[i].slot"
                  :key="'A' + i"
                >
                  {{ item }}
                </td>
                <td v-else-if="name != 'usedDataList'" :key="'A' + i">
                  <!-- karena posisi index thead sudah sync dengan body, jadi bisa menggunakan thead[i] -->
                  <slot :name="thead[i].slot" :list="list"></slot>
                </td>
              </template>
            </tr>
            <slot name="newRow"></slot>
          </tbody>
        </table>
        <div
          v-if="listsLocalSearch.length == 0"
          class="text-status-error w-full text-center p-4 border rounded-b sticky left-0"
        >
          Data yang anda cari tidak dapat kami temukan, coba menggunakan kata
          lainnya.
        </div>
      </div>
      <div
        v-if="listsLocalSearch.length > 0"
        class="flex text-sm flex-wrap justify-between pt-8 place-items-center"
      >
        <div
          class="text-neutral-5 text-center sm:text-left w-full sm:w-auto pb-2"
        >
          Menampilkan {{ maxItems * currentPage + 1 }} -
          {{
            listsLocalSearch.length > 0 &&
            listsLocalChunk[currentPage].length >= maxItems
              ? listsLocalChunk[currentPage].length * (currentPage + 1)
              : listsLocalSearch.length
          }}
          dari {{ listsLocalSearch.length }} Entri
        </div>
        <div
          class="justify-center w-full sm:w-auto sm:justify-self-start flex flex-wrap select-none"
        >
          <div
            class="px-1 font-bold-pop"
            :class="
              listsLocal && currentPage > 0
                ? 'cursor-pointer'
                : 'cursor-not-allowed text-neutral-4'
            "
            @click="currentPage > 0 && currentPage--"
          >
            <font-awesome :icon="['fa', 'angle-left']" />
            <span class="hidden sm:inline-block">Sebelumnya</span>
          </div>
          <div class="px-1 text-neutral-3">Hal.</div>
          <input
            class="w-40 text-center border rounded border-secondary-3"
            :value="currentPage + 1"
            type="number"
            :min="1"
            :max="listsLocalChunk.length"
            @input="inputPage"
          />
          <div class="px-1 text-neutral-3">
            Dari {{ listsLocalChunk.length }}
          </div>
          <div
            class="font-bold-pop px-1"
            :class="
              listsLocal &&
              listsLocalChunk.length > 1 &&
              currentPage + 1 < listsLocalChunk.length
                ? 'cursor-pointer'
                : 'cursor-not-allowed text-neutral-4'
            "
            @click="currentPage + 1 < listsLocalChunk.length && currentPage++"
          >
            <span class="hidden sm:inline-block">Lanjut</span>
            <font-awesome :icon="['fa', 'angle-right']" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    thead: {
      type: Array,
      default: () => [],
    },

    maxItems: {
      type: Number,
      default: 10,
    },
    lists: {
      type: Array,
      default: () => [],
    },
    usedDataList: {
      type: Array,
      default: () => [],
    },
    search: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data() {
    return {
      active: "",
      isFocus: false,
      searchInput: "",
      ascending: "",
      listsLocalSearch: [],
      listsLocalChunk: [],
      currentPage: 0,
    };
  },
  methods: {
    inputPage(event) {
      if (event.target.value > this.listsLocalChunk.length) {
        event.target.value = this.listsLocalChunk.length;
      } else if (event.target.value <= 0 && event.target.value !== "") {
        event.target.value = 1;
      }
      event.target.value !== "" && (this.currentPage = event.target.value - 1);

      // event.target.value > this.listsLocalChunk.length
      //   ? ((event.target.value = this.listsLocalChunk.length),
      //     (this.currentPage = this.listsLocalChunk.length - 1))
      //   : event.target.value
      //   ? (this.currentPage = event.target.value - 1)
      //   : ((this.currentPage = 0), (event.target.value = 1));
    },
    sortData(key, active) {
      this.active = active;
      if (this.ascending) {
        this.listsLocalSearch.sort((a, b) =>
          a[key].toString().localeCompare(b[key]),
        );
        this.setListsLocalChunk();
      } else {
        this.listsLocalSearch.sort((a, b) =>
          b[key].toString().localeCompare(a[key]),
        );
        this.setListsLocalChunk();
      }
      this.ascending = !this.ascending;
    },
    searchData() {
      this.listsLocalSearch = this.listsLocal.filter((data) => {
        return (
          data[this.search?.id || this.thead?.[0]?.id]
            .toLowerCase()
            .indexOf(this.searchInput?.toLowerCase()) > -1
        );
      });
      // console.log(
      //   this.listsLocal,
      //   this.listsLocalSearch,
      //   this.searchInput,
      //   this.search?.id || this.thead?.[0]?.id
      // );
      this.currentPage = 0;
      this.setListsLocalChunk();
    },
    refreshData() {
      this.listsLocalSearch = this.listsLocal.filter((data) => {
        return (
          data[this.search?.id || this.thead?.[0]?.id]
            ?.toLowerCase()
            ?.indexOf(this.searchInput?.toLowerCase()) > -1
        );
      });
      this.setListsLocalChunk();
    },
    resolvePath: (object, path, defaultValue) =>
      path
        .split(".")
        .reduce((o, p) => (o || o === 0 ? o[p] : defaultValue), object),
    chunks: function* (arr, n) {
      for (let i = 0; i < arr.length; i += n) {
        yield arr.slice(i, i + n);
      }
    },
    setListsLocalChunk: function () {
      // this.listsLocalSearch = this.listsLocal;
      this.listsLocalChunk = [
        ...this.chunks(this.listsLocalSearch, this.maxItems),
      ];
    },
    // listsLocalSearch(){
    //   this.listsLocalSearch
    // }
  },
  watch: {
    listsLocal(e) {
      console.log("Ketemu jalan keluarr,....", e);
      this.refreshData();
    },
    listsLocalShow(e) {
      console.log("localSHow", e);
      this.currentPage != 0 && e.length <= 0 && (this.currentPage -= 1);
    },
  },
  computed: {
    listsLocalShow() {
      return this.listsLocalChunk?.[this.currentPage] || [];
    },
    listsLocal() {
      const data =
        this.lists &&
        this.lists.map((data) => {
          const opt = {};
          this.thead.forEach((obj) => {
            obj.id && (opt[obj.id] = this.resolvePath(data, obj.id) ?? "");
            !obj.id && (opt.id = true);
          });
          if (this.usedDataList.length > 0) {
            this.usedDataList.forEach((usedListObj) => {
              opt.usedDataList ? "" : (opt.usedDataList = {});
              opt.usedDataList[usedListObj] = this.resolvePath(
                data,
                usedListObj,
              );
            });
          }
          return opt;
        });
      // this.listsLocalSearch = data;
      // this.setListsLocalChunk();
      // this.searchData();
      return data;
    },
    slotList() {
      return this.actionSlots.map((data) => data.slot);
    },
    actionSlots() {
      return this.thead.filter((data) => data.slot !== undefined);
    },
  },
  mounted() {
    // this.actionSlots = this.thead.filter(data => data.slot !== undefined);
    // this.slotList = this.actionSlots.map(data => data.slot);
    this.listsLocalSearch = this.listsLocal;
    this.listsLocal && this.setListsLocalChunk();
  },
};
</script>

<style lang="scss">
.table__primary {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
    width: 40px;
  }
  input .max-content {
    width: max-content;
  }

  svg {
    width: 20px !important;
  }

  .status-pill {
    @apply px-4;
    @apply rounded-full;
    @apply max-w-max;
    @apply mx-auto;
    @apply py-1;
  }

  .table {
    &__title {
      @apply font-normal;
      @apply text-neutral-white;
      @apply p-5;
      background: #034694;
      &.--sort {
        transition: all ease 0.3s;
        &:hover {
          @apply cursor-pointer;
          @apply text-yellow-400;
        }
      }
    }
    tr {
      &:nth-child(odd) {
        background-color: #fefefe;
      }
      &:nth-child(even) {
        background-color: #f9fafb;
      }
      td {
        @apply p-3;
        @apply text-center;
      }
    }
  }
}
</style>
